/**
 * Payment Service
 * Handles all payment, debt, and imputation-related API calls
 */

export {
  // Payment CRUD
  addPaymentApi,
  getPaymentApi,
  showPaymentApi,
  createPaymentApi,
  deletePaymentApi,
  listPaymentsAllApi,
  updatePaymentApi,
  
  // Debt management
  debtsPerDayApi,
  listDebtsLastPerDayApi,
  getDebtLastApi,
  cancelDebtApi,
  
  // Debt imputation
  addDebtImputationApi,
  imputationForDateApi,
  finalDebtForDateApi,
  
  // Annulation (cancellation) management
  getAnnulationResteApi,
  flipAnnulationPaidToResteApi,
  
  // Invoice generation
  generatePaymentInvoiceApi,
} from './apiService';
